<template>
  <div class="object-detail">
    <div class="object-detail-wrap">
      <div class="object-plan">
        <img :src="object.resource_urls.plan">
      </div>
      <div class="object-info">
        <h1 class="object-title">{{object.number}}</h1>
        <table class="object-info-table detail-object-info-table">
          <tr v-if="object.data['floor_number']">
            <th>Våning</th>
            <td>{{object.data['floor_number']}}</td>
          </tr>
          <tr v-if="object.data['rooms']">
            <th>Antal rum</th>
            <td>{{object.data['rooms']}}</td>
          </tr>
          <tr v-if="object.data['living_area']">
            <th>Storlek</th>
            <td>{{object.data['living_area']}} m<sup>2</sup></td>
          </tr>
          <tr v-if="object.data['price']">
            <th>Pris</th>
            <td>{{object.data['price'].formatted}}</td>
          </tr>
          <tr v-if="object.data['monthly_fee']">
            <th>Avgift</th>
            <td>{{object.data['monthly_fee'].formatted}}</td>
          </tr>
          <tr>
            <th>Status</th>
            <td><span class="status-" :class="'status-'+object.status">{{object.status_name}}</span></td>
          </tr>
        </table>

        <a :href="object.resource_urls.pdf" target="_pdf" class="btn btn-link"><span class="icon icon-pdf"></span>Bofaktablad</a>

        <div class="object-info-footer">
          <router-link to=".." class="btn btn-link"><span class="icon icon-arrow-left"></span> Tillbaka</router-link>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  import ObjectList from '@/components/ObjectList'

  export default {
    name: 'ObjectDetail',
    props: ['widget'],
    data () {
      return {
        object: null
      }
    },
    computed: {
      ...mapGetters({
        allObjects: 'getObjects'
      })
    },
    watch: {
      '$route.params.objectId' (to, from) {
        this.load()
      }
    },
    created () {
      this.load()
    },
    mounted () {
    },
    methods: {
      load () {
        const id = this.$route.params.objectId
        this.object = this.$store.getters.getObject(+id)
        if (!this.object) {
          throw new Error('objekt hittas inte')
        }
      },
      onRowClick (object) {
      }
    },
    components: {
      'cw-object-list': ObjectList
    }
  }
</script>
<style scoped lang="scss">
  .object-detail {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 1001;
    background: #fff;
    display: flex;
    flex-direction: column;
  }

  .object-plan {
    img {
      max-width: 100%;
      max-height: 100%;
      height: auto;
    }
  }

  .detail-object-info-table {
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ObjectDetail.vue